<div
  class="dropdown-container"
  [class.disabled]="disabled"
  #container
  (click)="!disabled && toggleDropdown()"
>
  <div class="dropdown-trigger">
    @if (label) {
      <p class="label" [class.small]="selected || multiSelected.length">
        {{ label }}
      </p>
    }
    @if (multiselect) {
      <p class="selected-value">
        <span class="selected-number">{{
          multiSelected.length > 1 ? multiSelected.length : ""
        }}</span>
        {{ getMultiselectLabel() }}
      </p>
    } @else {
      <p class="selected-value">
        {{ selected ? getLabel(selected) : placeholder }}
      </p>
    }
  </div>
  <img
    class="chevron"
    [class.disabled]="disabled"
    [class.open]="dropdownOpen"
    src="/assets/images/grey-triangle.svg"
    alt="open dropdown image"
  />
  @if (dropdownOpen) {
    <ul class="dropdown-menu" #dropdownMenu>
      @if (searchable) {
        <div class="search">
          <img
            src="/assets/images/search.svg"
            alt="search"
            class="search-icon"
          />
          <input
            class="search-input"
            type="text"
            placeholder="Search..."
            [(ngModel)]="searchTerm"
            (keyup)="onSearchChange()"
            (keydown.enter)="onEnterPress()"
            (click)="$event.stopPropagation()"
          />
        </div>
      }
      @if (multiselect && options.length) {
        <li [class.selected]="selectAll" (click)="onSelectAll($event)">
          <img
            class="img"
            [class.selectedImg]="selectAll"
            src="/assets/images/tick-active.svg"
            alt="selected"
          />
          {{ selectAllLabel }}
        </li>
      }
      @for (option of searchResults; track $index) {
        <li
          (click)="onOptionClick(option, $event)"
          [class.selected]="isSelected(option)"
          [class.disabled]="option.isDisabled"
        >
          <img
            class="img"
            [class.selectedImg]="isSelected(option)"
            src="/assets/images/tick-active.svg"
            alt="selected"
          />
          {{ getLabel(option) }}
        </li>
      }

      @if (multiselect && options.length && multiselecWithtApply) {
        <div class="multiselect-ctas">
          <button class="cta" (click)="onCancelClick($event)">Cancel</button>
          <button class="cta" (click)="onApplyClick($event)">Apply</button>
        </div>
      }
    </ul>
  }
</div>
